import { jsx, jsxs } from 'react/jsx-runtime';
import { LazyImage, styled } from '@teko/ds-desktop';

const DetailGifts = ({ gifts, }) => (jsx("div", { children: gifts.map((gift, index) => (jsxs(StyledGift, { children: [jsx("div", { children: jsx(LazyImage, { height: 32, width: 32, border: true, borderRadius: 2, contain: true, src: (gift === null || gift === void 0 ? void 0 : gift.image.src) || '' }, void 0) }, void 0), jsxs(Quantity, { children: ["x", gift.quantity] }, void 0), jsx(GiftName, { children: gift.name }, void 0), gift.endAt && jsx(EndAt, { children: gift.endAt }, void 0)] }, index))) }, void 0));
const StyledGift = styled.div `
  display: flex;
  align-items: center;
  padding: 0.25rem 0;
`;
const GiftName = styled.span `
  margin-left: 0.25rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.75rem;
`;
const EndAt = styled.span(({ theme }) => `
    color: ${theme.colors.pending500};
    margin-left: 0.5rem;
    font-size: 0.75rem;
  `);
const Quantity = styled.span `
  font-size: 0.75rem;
  color: #848788;
  margin-left: 0.5rem;
`;

export { DetailGifts, Quantity };
